import { ToolkitStore } from "@reduxjs/toolkit/dist/configureStore";

class ReduxStoreWorker {
  private store: ToolkitStore | null = null;

  dispatch<P, R>(
    action: (payload: P) => (dispatch: ToolkitStore["dispatch"]) => R,
    payload: P
  ): R {
    if (!this.store) {
      throw new Error("Redux store has not been initialized");
    }
    return action(payload)(this.store.dispatch);
  }

  getState() {
    if (!this.store) {
      throw new Error("Redux store has not been initialized");
    }
    return this.store.getState();
  }

  getStore() {
    return this.store;
  }

  setStore(store: ToolkitStore) {
    this.store = store;
  }
}

const reduxStoreWorker = new ReduxStoreWorker();
export default reduxStoreWorker;
